import {
  Box,
  Divider,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { usePartnerProfileConfig } from '../Enrollment/usePartnerProfileConfig';

export const PartnerOffersSection = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { partnerOffers } = usePartnerProfileConfig();
  const offers = partnerOffers?.filter(
    (offer) => offer.isEnabled,
  )?.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

  return offers?.length === 0 ? null : (<><Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
      alignSelf: 'stretch',
    }}>
    <Typography variant='h4'>{t('partnerDetails.offers')}</Typography>
    {offers?.map((item, index) => (
      <Box
        data-testid={`partners-individual-offers-${index}`}
        key={index}
        sx={{
          display: 'flex',
          gap: theme.spacing(0.75),
          padding: theme.spacing(2),
          alignItems: 'center',
          alignSelf: 'stretch',
          flexWrap: 'wrap',
          borderRadius: theme.spacing(1.5),
          border: `1px solid ${theme.palette.grey[300]}`,
          background: theme.palette.brand.surface,
          /* Shadows/shadow-lg */
          boxShadow: '0 12px 16px -4px rgba(10, 13, 18, 0.08), 0 4px 6px -2px rgba(10, 13, 18, 0.03), 0 2px 2px -1px rgba(10, 13, 18, 0.04)',
        }}>
        {item.title && <Typography variant='h15'>{item.title}: </Typography>}
        <Typography variant='body8'
          color={theme.palette.grey[700]}
        >{item.description}
        </Typography>
      </Box>
    ))}
  </Box>
  <Divider />
  </>
  );
};
